import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

const Label = ({ children }: PropsWithChildren) => {
	return <Typography>{children}</Typography>;
};

export default Label;
